import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSeo } from "@/hooks/useSeo";
import { useLang } from "@/context/LanguageContext";

export default function NotFound() {
  const { L } = useLang();
  const P = L.pages.notFound;
  useSeo({ title: P.title, noindex: true });
  return (
    <section className="relative flex min-h-[70vh] items-center overflow-hidden bg-navy">
      <div className="absolute inset-0 grid-lines opacity-50" />
      <div className="container-tight relative text-center">
        <p className="font-heading text-7xl font-bold text-gold">404</p>
        <h1 className="mt-4 font-heading text-3xl font-bold text-white lg:text-4xl">{P.title}</h1>
        <p className="mt-4 text-slate-300">{P.desc}</p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Button asChild size="lg" className="bg-finblue hover:bg-finblueDark" data-testid="notfound-home"><Link to="/">{P.home}</Link></Button>
          <Button asChild size="lg" variant="outline" className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white" data-testid="notfound-markets"><Link to="/markets">{P.markets}</Link></Button>
        </div>
      </div>
    </section>
  );
}
